<template>
    <div class="ql-editor" v-html="html"></div>
</template>

<script>
export default {
    props:{
        html:String
    },
}
</script>